<template>
  <div class="header clearfix">
    <div class="container">
      <nav class="cs-nav nav navbar-default" toggleable="xs">
        <div class="navbar-header">
          <button
            type="button"
            class="cs-toogle-btn visible-xs"
            @click="toogleExpand"
          >
            <!-- <i class="el-icon-close"></i> -->
            <span v-if="!expanded" class="icon iconfont iconzu"></span>
            <!-- <span class="glyphicon glyphicon-menu-hamburger"></span> -->
            <span v-else class="icon iconfont iconzu1"></span>
          </button>
          <div class="navbar-brand">
            <router-link :to="{ path: '/' }">
              <img src="@/assets/images/icon_logo.png" alt />
              <img
                class="txt-logo"
                src="@/assets/images/WechatIMG181.png"
                alt=""
              />
              <!-- <span>掌上公交</span> -->
            </router-link>
          </div>
        </div>

        <div class="navbar-body hidden-xs" id="navbar-toogle-collapse">
          <div class="nav navbar-nav navbar-right nav-ul">
            <el-menu
              :default-active="activeIndex"
              class="menu"
              text-color="#333"
              active-text-color="#fff"
              router
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="/home">首页</el-menu-item>
              <el-submenu
                class="submenu"
                popper-class="menu-popover"
                index="/about"
              >
                <template slot="title" @click="jumpAbout">关于我们</template>
                <el-menu-item index="/about">
                  <a href="#intro">公司简介</a>
                </el-menu-item>
                <el-menu-item index="/about">
                  <a href="#development">发展历程</a>
                </el-menu-item>
                <el-menu-item index="/about">
                  <a href="#product">产品介绍</a>
                </el-menu-item>
                <el-menu-item index="/about">
                  <a href="#map">联系我们</a>
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="/media">媒体报道</el-menu-item>
              <el-menu-item index="/joinus">加入我们</el-menu-item>
              <el-menu-item class="menu-item">
                <a class="custom-a-link" href="http://platform.mygolbs.com" target="_blank">商城</a>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </nav>
    </div>

    <div
      v-if="expanded"
      class="visible-xs mobile-menu"
      id="mobile-menu"
      @click.stop="toogleExpand"
    >
      <ul>
        <li
          @click.stop="toogleExpand"
          :class="{ active: activeIndex === '/home' }"
        >
          <router-link :to="{ path: '/home' }">首页</router-link>
        </li>
        <li
          @click.stop="toogleExpand"
          :class="{ active: activeIndex === '/about' }"
        >
          <router-link :to="{ path: '/about' }">关于我们</router-link>
        </li>
        <li
          @click.stop="toogleExpand"
          :class="{ active: activeIndex === '/media' }"
        >
          <router-link :to="{ path: '/media' }">媒体报道</router-link>
        </li>
        <li
          @click.stop="toogleExpand"
          :class="{ active: activeIndex === '/joinus' }"
        >
          <router-link :to="{ path: '/joinus' }">加入我们</router-link>
        </li>
        <li
          @click.stop="toogleExpand"
        >
          <a href="http://platform.mygolbs.com" target="_blank">商城</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routerUrl: "",
      expanded: false,
      showOverlay: false,
      showMenuPopover: false,
      activeIndex: "",
    };
  },
  mounted() {
    this.activeIndex = this.$route.path;
  },
  methods: {
    jump(e) {
      this.$emit("scrollIntoView", e);
    },
    jumpAbout() {
      console.log("jump");
      this.$route.push({
        path: "/about",
      });
    },
    toogleExpand() {
      // console.log("toogleExpand");
      this.expanded = !this.expanded;
      this.showOverlay = !this.showOverlay;
      // console.log(this.showOverlay);
      let preD = function (e) {
        e.preventDefault();
      };
      if (this.showOverlay) {
        $("html,body").css("overflow", "hidden");
        // document.addEventListener("touchmove", preD, { passive: false });
      } else {
        // console.log("hidden Overlay");
        $("html,body").css("overflow", "");
        // document.removeEventListener("touchmove", preD, { passive: false });
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./header.less";
</style>
<style lang="less">
.overlay {
  position: fixed;
  top: 3.5625px;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 0;
}
// 菜单设置
.menu {
  padding: 29px 0; /*no*/

  border-bottom: 0 !important;
  .el-menu-item,
  .submenu {
    height: 32px; /*no*/
    line-height: 32px; /*no*/
    padding: 0 20px; /*no*/
    border: none;
    border-radius: 86px; /*no*/

    &:hover {
      color: #ff6000 !important;
    }
  }
  .el-menu-item.is-active,
  .submenu.is-active {
    border: none;
    background: rgba(255, 92, 0, 1);
    box-shadow: 0px 3px 6px rgba(255, 92, 0, 0.16); /*no*/
    &:hover {
      color: #fff !important;
      background: #ff6000;
    }
    .el-submenu__title {
      border: none;
    }
  }
}
.el-submenu {
  .el-submenu__title {
    border: none !important;
    height: 32px !important; /*no*/
    line-height: 32px !important; /*no*/
    padding: 0;
    &:hover {
      color: #ff6000 !important;
      i {
        color: #ff6000 !important;
      }
    }
    i {
      color: #333;
    }
  }
}
.el-submenu.is-active {
  border: none !important;
  background: rgba(255, 92, 0, 1) !important;
  .el-submenu__title {
    border: none !important;
    background: rgba(255, 92, 0, 1) !important;
    box-shadow: 0px 3px 6px rgba(255, 92, 0, 0.16) !important; /*no*/
    i {
      color: #fff;
    }
    &:hover {
      color: #fff !important;
      i {
        color: #fff !important;
      }
    }
  }
}

.menu-popover {
  .el-menu--popup {
    min-width: 140px; /*no*/
    padding: 15px 0; /*no*/
    text-align: center;
  }
  .el-menu-item {
    min-width: 140px; /*no*/
    a {
      color: #333;
      text-decoration: none;
      &:hover {
        color: #ff6000;
      }
    }
  }
  .el-menu-item.is-active {
    box-shadow: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue